module.exports = {	
	'Connect Wallet' : 'Connect Wallet',
	'Lossless mining' : 'Lossless mining',
	'Liquidity pledge-free' : 'Liquidity pledge-free',
	'Reward' : 'Reward',
	'Million' : '1 Million',
	'Receive Voucher' : 'Receive Voucher',
	'Invite Friends' : 'Invite Friends',
	'Mining Pool' : 'Mining Pool',
	'Account' : 'Account',

	'Pool data' : 'Pool data',
	'Valid node' : 'Valid node',
	'Participant' : 'Participant',
	'User Revenue' : 'User Revenue',
	'Mining' : 'Mining',
	'Liquidity mining income' : 'Liquidity mining income',
	'User Output' : 'User Output',
	'Address' : 'Address',
	'Help center' : 'Help center',
	'Hope it helps you' : 'Hope it helps you',
	'How do i need to join？' : 'How do i need to join？',
	'Participating in non-destructive and non-guaranteed liquidity mining requires payment of ETH miner fees to receive the replacement gold coupons, and the ETH wallet address only needs to be claimed once. Automatically open mining permissions after success.' : 'Participating in non-destructive and non-guaranteed liquidity mining requires payment of ETH miner fees to receive the replacement gold coupons, and the ETH wallet address only needs to be claimed once. Automatically open mining permissions after success.',
	'How do i withdraw money？' : 'How do i withdraw money？',
	'You can convert the currency generated every day into USDT, and then initiate a withdrawal. USDT withdrawals will be automatically sent to the wallet address you added to the node, other addresses are not supported.' : ' You can convert the currency generated every day into USDT, and then initiate a withdrawal. USDT withdrawals will be automatically sent to the wallet address you added to the node, other addresses are not supported. ',
    'How to calculate income？':'How to calculate income？',
    'When you join successfully, the smart contract starts to calculate your address through the node and start to calculate the revenue.' : ' When you join successfully, the smart contract starts to calculate your address through the node and start to calculate the revenue. ',
    'What is revenue？':'What is revenue？',
    'The yield below1000USDT≈0.5%~0.6%, ' : 'The yield below1000USDT≈0.5%~0.6%, ',
    '1000USDT-5000USDT≈1.6%~2.0%, ' : '1000USDT-5000USDT≈1.6%~2.0%, ',
    '5000USDT-20000USDT yield≈1.8%~2.2%, ' : '5000USDT-20000USDT yield≈1.8%~2.2%, ',
    '20000USDT-50000USDT yield≈2.2%~2.6%, ' : '20000USDT-50000USDT yield≈2.2%~2.6%, ',
    '50000USDT-200000USDT yield≈2.6%~3.0%, ' : '50000USDT-200000USDT yield≈2.6%~3.0%, ',
    'and above 200000USDT yield Rate≈2.8%~3.5% ' : 'and above 200000USDT yield Rate≈2.8%~3.5% ',
    'What are the extra gains？' : 'What are the extra gains？',
    'You can share our page to a friend, if he joins, you can get 10% of his income as a bonus,your sharing link is on the top left corner of the homepage to get.' : 'You can share our page to a friend, if he joins, you can get 10% of his income as a bonus,your sharing link is on the top left corner of the homepage to get.',
	'My account' : 'My account',
	'Total output' : 'Total output',
	'Wallet balance' : 'Wallet balance',
	'Exchangeable' : 'Exchangeable',
	'Withdrawable' : 'Withdrawable',
	'Exchange' : 'Exchange',
	'Withdraw' : 'Withdraw',
	'Record' : 'Record',
	'Redeem all' : 'Redeem all',
	'Total balance' : 'Total balance',
	'Confirm' : 'Confirm',
	'Time' : 'Time',
	'Quantity' : 'Quantity',
	'Status' : 'Status',
	'No Data' : 'No Data',
	'Output' : 'Output',
	'Fee' : 'Fee',
	'Scope' : 'Scope',
	'Daily acceptance times' : 'Daily acceptance times：',
	'Your withdrawal will be sent to your USDT wallet address within 24 hours in the future' : 'Your withdrawal will be sent to your USDT wallet address within 24 hours in the future',
	'Audit report' : 'Audit report',
	'We have a secure audit report' : 'We have a secure audit report',
	'Partner' : 'Partner',
	'our business partner' : 'our business partner',
	'Share friends' : 'Share friends',
	'My share link' : 'My share link',
	'Copy' : 'Copy',
	"Send your invitation link, friends join the node through your link, and you will get generous token rewards.You can get 10% of the recommended person's income" : "Send your invitation link, friends join the node through your link, and you will get generous token rewards.You can get 10% of the recommended person's income",
	'There was an issue signing you in.' : 'There was an issue signing you in.',
	'Receive description' : 'Receive description',
	"You need to pay a miner's fee to receive the voucher, please make sure that your wallet has enough ETH as the miner's fee" : "You need to pay a miner's fee to receive the voucher, please make sure that your wallet has enough ETH/TRX as the miner's fee",
	"Receive" : "Receive",
	"You have successfully joined the node and started mining" : "You have successfully joined the node and started mining",
}


// WEBPACK FOOTER //
// ./src/assets/lang/en.js